import React from "react";

const context = React.createContext();
context.displayName = "ReCAPTCHASiteKeyContext";

export default context;
